// src/app/%28full-width-pages%29/%28auth%29/signin/page.tsx
import { createFileRoute } from '@tanstack/react-router'
import SignUpForm from "@/components/auth/SignUpForm";
import type { Metadata } from "next";

export const metadata: Metadata = {
  title: "Next.js SignUp Page | TailAdmin - Next.js Dashboard Template",
  description: "This is Next.js SignUp Page TailAdmin Dashboard Template",
  // other metadata
};

function SignUp() {
  return <SignUpForm />;
}

export const Route = createFileRoute('/(authentication)/(auth)/signup/')({
  component: SignUp,
})
